// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NT4ryEwUsITLPCwqSp1g{flex-direction:column;gap:6px;display:flex}.P1e0F8W1w5sZdHpu_Njz{background:var(--background-neutral-default);word-break:break-word;white-space:pre-wrap;border-radius:12px;max-width:200px;padding:11px}.Lv1UagfvTzsh60D6ym4f{background:var(--background-brand-subtle-primary);color:var(--content-primary-primary);border-radius:6px;align-self:flex-end;padding:8px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NT4ryEwUsITLPCwqSp1g`,
	"bubble": `P1e0F8W1w5sZdHpu_Njz`,
	"replyBubble": `Lv1UagfvTzsh60D6ym4f`
};
export default ___CSS_LOADER_EXPORT___;
